import { Dispatch, SetStateAction } from "react"
import { EcleanCuration } from "../GenerateDSComponents/Curate"
import InfoTooltip from "../../../../components/Buttons/InfoTooltip"
import ConditionalSelectField from "../../../../components/Form/ConditionSelectField"
import SelectField from "../../../../components/Form/SelectFields"

export default function StandardizeBinaryValues({
    showSelect,
    form,
    setForm,
    fieldOptions,
    menuPortalTargetId
}: {
    showSelect: boolean,
    form: EcleanCuration,
    setForm: Dispatch<SetStateAction<EcleanCuration>>,
    fieldOptions: {
        value: string,
        label: string
    }[],
    menuPortalTargetId: string,
}) {

    const handleSelectStdBinaryValues = (e: any, name: string) => {
        const value = e.value;

        if (form.eclean_std_binary_values) {
            setForm({
                ...form,
                eclean_std_binary_values: {
                    ...form.eclean_std_binary_values,
                    [name]: value,
                },
                eclean_std_binary: form.eclean_std_binary ? {
                    ...form.eclean_std_binary,
                    [name]: value,
                } : null,
            })
        }
    }

    
    return (
        <>
        {form.eclean_std_binary_values !== null && (
            // Single-class & continuous
            <div className="flex flex-col gap-6 justify-start items-start">
                <div className="flex justify-start items-center gap-2">
                    <p className="text-default font-semibold">{form.eclean_std_smiles !== null ? '2' : '1'}. Standardize Binary Values</p>
                    <InfoTooltip 
                        btnWidth="14px"
                        title="Standardize Binary Values"
                        content={
                            <div className="flex flex-col gap-3 text-placeholder text-[12px]">
                                <p className="max-w-[300px]">This pipeline drops missing binary values, converts values to 0 or 1, and drops those binary values which are not 0 or 1.</p>
                            </div>
                        }
                    />
                </div>
                <div className="w-full flex justify-between items-end gap-4">
                    <ConditionalSelectField label='Binary value column' showSelect={showSelect}>
                        <SelectField 
                            label="Binary value column"
                            id="binary_value_column"
                            name="binary_value_column"
                            value={form.eclean_std_binary_values.binary_value_column ? {
                                value: form.eclean_std_binary_values.binary_value_column,
                                label: form.eclean_std_binary_values.binary_value_column
                            } : null}
                            options={fieldOptions}
                            isRequired={true}
                            isCreatable={false}
                            isMulti={false}
                            handleChange={handleSelectStdBinaryValues}
                            menuPortalTarget={menuPortalTargetId ? document.getElementById(menuPortalTargetId) : document.getElementById('curate-ds-popup')}
                            />
                    </ConditionalSelectField>
                </div>
            </div>
        )}
        </>
    )
}